<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="3">
        <div class="form-group">
          <label for="datepicker">Từ ngày - đến ngày</label>
          <DatePicker locale="vi" id="datepicker" v-model="dateRange" :model-config="dateRangeConfig" :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }" is-range class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="inputValue.start + ' - ' + inputValue.end"
                v-on="inputEvents.start"
                class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                readonly
              />
            </template>
          </DatePicker>
        </div>
      </CCol>
      <CCol sm="3" xs="12" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')">
        <BaseSelect
          :options="districtCodeInput.options"
          :data="districtCodeInput.data"
          ref="districtCodeInput"></BaseSelect>
      </CCol>
      <CCol sm="3" xs="12" v-if="!$hasAuthor('ROLE_WARD')">
        <BaseSelect
          :options="wardCodeInput.options"
          :data="wardCodeInput.data"
          ref="wardCodeInput"></BaseSelect>
      </CCol>
    </CRow>
    <CRow class="row-2">
      <CCol sm="3" xs="12">
        <BaseInput
          :options="titleInput.options"
          :data="titleInput.data"
          :listener="titleInput.listener"
        />
      </CCol>
      <CCol sm="3" xs="12">
        <BaseSelect
          :options="sourceTypeSelect.options"
          :data="sourceTypeSelect.data"
          ref="sourceTypeSelect"
        ></BaseSelect>
      </CCol>
      <CCol sm="3" xs="12">
        <BaseSelect :options="departmentsInput.options" :data="departmentsInput.data"
                    ref="departmentsInput"></BaseSelect>
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right; margin-left: 5px"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;&nbsp; Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable">
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>

          <template #createDate="{ item }">
            <td v-if="item.createDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
            <td v-if="item.createDate == null"></td>
          </template>
          <template #description="{ item }">
            <td>
              <span class="description" :key="item.id" v-c-tooltip.hover="item.description">{{ item.description }}</span>
            </td>
          </template>
          <template #level="{ item }">
            <td>
              <span class="badge badge-success" v-if="item.level == 0">Bình thường</span>
              <span class="badge badge-warning" v-else-if="item.level == 1">Ưu tiên</span>
              <span class="badge badge-danger" v-else-if="item.level == 2">Khẩn cấp</span>
            </td>
          </template>
          <template #sourceType="{ item }">
            <td>
              <span class="badge badge-light" v-if="item.sourceType == 0">Bản tin TW</span>
              <span class="badge badge-light" v-else-if="item.sourceType == 1">Biên tập</span>
              <span class="badge badge-light" v-else-if="item.sourceType == 2">Chuyển đổi văn bản</span>
              <span class="badge badge-light" v-else-if="item.sourceType == 3">Ghép tệp tin</span>
              <span class="badge badge-light" v-else-if="item.sourceType == 4">Ghi âm tệp tin</span>
            </td>
          </template>
          <template #fileTypeName="{ item }">
            <td>
              <span class="badge badge-light">{{ item.fileTypeName }}</span>
            </td>
          </template>
          <template #url="{ item }">
            <td>
              <span class="view-file" v-if="item.url" @click="viewFile(item.url)">Ấn vào để xem tệp</span>
            </td>
          </template>
          <template #action="{ item }">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Tải xuống'"
                  square
                  size="sm"
                  @click="downloadFile(item.url)"><i class="fa fa-download"></i>
                </CButton>
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Gửi tới đài'"
                  square
                  size="sm"
                  @click="sendToStation(item)"><i class="fa fa-send"></i>
                </CButton>
                <CButton v-if="!$hasAuthor('ROLE_WARD')"
                         color="info"
                         variant="outline"
                         v-c-tooltip.hover="'Chia sẻ'"
                         square
                         size="sm"
                         @click="shareFile(item.id)"
                ><i class="fa fa-share"></i>
                </CButton>
<!--                <CButton-->
<!--                  color="danger"-->
<!--                  variant="outline"-->
<!--                  square-->
<!--                  size="sm"-->
<!--                  v-c-tooltip.hover="'Xóa'"-->
<!--                  @click="setupSelectOneAction('delete_one', item.id, item.title)">-->
<!--                  <CIcon name="cil-trash"/>-->
<!--                </CButton>-->
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>

    <CModal title="Chia sẻ tệp tin" :show.sync="isShowPopupShareFile" size="lg" :closeOnBackdrop="false">
      <CRow class="content-fade-in">
        <CCol md="12">
          <CForm class="form-basic">
            <CRow>
              <CCol sm="12" md="12" xl="12">
                <BaseSelect v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')"
                            :options="shareFileData.districtCodeInput.options"
                            :data="shareFileData.districtCodeInput.data"
                            ref="shareFileDistrictCodeInput"
                ></BaseSelect>
              </CCol>
              <CCol sm="12" md="12" xl="12" class="mb-2">
                <div class="form-group">
                  <label>Phường/Xã <span class="required">*</span></label>
                  <multiselect
                    class="mt-2"
                    v-model="shareFileData.wardCodeInput.data.model"
                    placeholder="Chọn phường/xã"
                    label="value"
                    track-by="key"
                    :options="shareFileData.wardCodeInput.data.items"
                    selectLabel="Chọn"
                    deselectLabel="Bỏ chọn"
                    selectedLabel="Đã chọn"
                    :close-on-select="false"
                    :multiple="true"
                    :class="!(shareFileData.wardCodeInput.data.validator ? shareFileData.wardCodeInput.data.validator.isValid : true) ? 'input-error' : ''"
                  >
                    <span slot="noResult">Không có dữ liệu tương ứng!</span>
                    <span slot="noOptions">Danh sách rỗng!</span>
                  </multiselect>
                  <div class="valid-error"
                       v-show="!(shareFileData.wardCodeInput.data.validator ? shareFileData.wardCodeInput.data.validator.isValid : true)">
                    {{
                      shareFileData.wardCodeInput.data.validator ? shareFileData.wardCodeInput.data.validator.errorMessage : ""
                    }}
                  </div>
                </div>
              </CCol>
            </CRow>
          </CForm>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <div slot="footer">
          <button type="button" class="btn btn-secondary" @click="isShowPopupShareFile = false"
                  :disabled="loadingShareFile.value"><i
            class="fa fa-close"></i> Hủy bỏ
          </button>&nbsp;
          <button type="button" class="btn btn-primary" @click="submitShareFile()" :disabled="loadingShareFile.value">
            <i class="fa fa-share"></i> Chia sẻ
          </button>
        </div>
      </template>
      <BaseFormLoading :loading="loadingShareFile.value"></BaseFormLoading>
    </CModal>

    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>

    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "../../base/BaseDataTable";
import ModalConfirm from "../../base/BaseModalConfirm";
import BaseInput from "../../base/BaseInput";
import BaseSelect from "../../base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import {LOCATION_CODE_NAME, Roles} from "../../../constant";
import Multiselect from "vue-multiselect";
import {DatePicker} from "v-calendar";

export default {
  name: "AudioFileList",
  components: {
    BaseFormLoading,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    Multiselect,
    DatePicker
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;

    let actionTypeMapping = new Map();

    actionTypeMapping.set("delete_one", {
      url: "/audio-file/delete",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "bản tin",
          that.actionData.model.fileName
        );
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.fileId,
        };
      },
      successCallback: function () {
        that.showSuccessMsg({message: "Xóa bản tin " + that.actionData.model.fileName + " thành công"});
        that.loadDataMainTable();
      }
    });

    return {
      loading: {value: false},
      loadingShareFile: {value: false},
      isShowPopupShareFile: false,
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          fileId: null,
          fileName: null
        }
      },
      dateRange: {
        start: that.$helper.subtractNowDate(30).setHours(0, 0, 0, 0),
        end: new Date().setHours(23, 59, 59, 999)
      },
      dateRangeConfig: {
        start: {
          timeAdjust: '00:00:00',
        },
        end: {
          timeAdjust: '23:59:59',
        },
      },
      shareFileData: {
        fileId: {
          name: 'fileId',
          model: ''
        },
        districtCodeInput: {
          options: {
            filter: true,
            label: "Quận/Huyện <span class='required'>*</span>",
            selectAllText: "Chọn Quận/Huyện",
            keyField: "key",
            valueField: "value",
            lazyLoad: true,
          },
          data: {
            name: "districtCode",
            items: [],
            model: null,
            source: {
              url: "/common/findByParentCodeAndCode",
              dataSubmit: function () {
                return {};
              },
              response: function (dataResponse) {
                that.shareFileData.districtCodeInput.data.items = dataResponse.data;
              },
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.shareFileData.districtCodeInput.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Quận/Huyện không được để trống";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              },
            }
          },
        },
        wardCodeInput: {
          data: {
            name: "wardCode",
            model: [],
            items: [],
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.shareFileData.wardCodeInput.data.model;
                if (!value || value.length === 0) {
                  this.isValid = false;
                  this.errorMessage = "Phường/xã không được để trống";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              },
            },
          },
        },
      },
      titleInput: {
        options: {
          placeholder: "Tiêu đề bản tin",
          label: "Tiêu đề bản tin",
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      sourceTypeSelect: {
        options: {
          filter: false,
          label: "Nguồn bản tin",
        },
        data: {
          name: "sourceType",
          items: [
            {key: "null", value: "Tất cả nguồn bản tin"},
            {key: "0", value: "Bản tin TW"},
            {key: "1", value: "Bản tin biên tập"},
            {key: "2", value: "Chuyển đổi văn bản"},
            {key: "3", value: "Ghép tệp tin"},
            {key: "4", value: "Ghi âm tệp tin"},
          ],
          model: "null",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          keyField: "key",
          valueField: "value",
          lazyLoad:
            this.$hasAuthor("ROLE_ADMIN") || this.$hasAuthor("ROLE_PROVINCE")
              ? false
              : true,
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: "/common/findByParentCodeAndCode",
            dataSubmit: function () {
              return {};
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            },
          },
        },
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          keyField: "key",
          valueField: "value",
          lazyLoad: this.$hasAuthor("ROLE_DISTRICT") ? false : true,
          disabled: this.$hasAuthor('ROLE_DISTRICT') ? false : true
        },
        data: {
          name: "wardCode",
          model: null,
          items: [],
          source: {
            url: "/common/findByParentCodeAndCode",
            dataSubmit: function () {
              return {
                parentCode:
                  that.districtCodeInput.data.model
              };
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            },
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      departmentsInput: {
        options: {
          filter: true,
          label: "Lĩnh vực",
          selectAllText: "Tất cả lĩnh vực",
        },
        data: {
          name: "fileTypeId",
          items: [],
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      locationCode: {
        data: {
          name: "locationCode",
          model: "",
        },
      },
      mainTable: {
        options: {
          fields: [
            {key: "index", label: "STT"},
            {key: "createDate", label: "Ngày tạo", _style: "max-width:5%; width:5%"},
            {key: "title", label: "Tiêu đề"},
            {key: "description", label: "Mô tả"},
            {key: "fileTypeName", label: "Lĩnh vực"},
            {key: "sourceType", label: "Nguồn bản tin"},
            {key: "duration", label: "Thời lượng"},
            {key: "level", label: "Cấp độ"},
            {key: "url", label: "Tệp"},
            {key: "location", label: "Địa bàn tạo"},
            {key: "action", label: "Thao tác"},
          ],
          slots: [
            "index",
            "createDate",
            "action",
            "level",
            "url",
            "sourceType",
            "fileTypeName",
            "description"
          ],
          lazyLoad: this.$hasAuthor('ROLE_WARD') ? true : false,
          pageSize: 15
        },
        dataSource: {
          url: "/audio-file/getPages",
          dataSubmit: function () {
            var params = that.$helper.setupDataSubmit(that.$data);
            params.fromDate = that.$helper.formatDate(that.dateRange.start);
            params.toDate = that.$helper.formatDate(that.dateRange.end);
            return params;

          },
          response(dataResponse) {
            return dataResponse.data;
          },
        },
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    async viewFile(url) {
      // let that = this;
      // this.loading.value = true;
      // const data = await this.$helper.blobFileByUrl(url);
      // setTimeout(() => {
      //   that.loading.value = false;
      //   window.open(data);
      // }, 500);
      window.open(this.$helper.viewFileByUrl(url));
    },
    async downloadFile(url) {
      this.loading.value = true;
      const imgUrl = await this.$helper.blobFileByUrl(url);
      this.loading.value = false;
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.href = imgUrl;
      a.download = url.substring(url.lastIndexOf("/") + 1, url.length);
      a.click();
    },
    sendToStation: function (item) {
      let that = this;
      that.$router.push({
        name: "Gửi bản tin tới đài truyền thanh",
        query: {fileId: item.id, sourceType: item.sourceType},
      });
    },
    shareFile: function (fileId) {
      this.shareFileData.fileId.model = fileId;
      if (this.$hasAuthor(Roles.ADMIN) || this.$hasAuthor(Roles.PROVINCE)) {
        this.$refs.shareFileDistrictCodeInput.loadData();
      } else if (this.$hasAuthor(Roles.DISTRICT)) {
        this.loadDataWard();
      }
      this.isShowPopupShareFile = true;
    },
    loadDataWard: function (parentCode) {
      let that = this;
      this.$helper.loadDataSource({
        url: '/common/findByParentCodeAndCode',
        dataSubmit() {
          return {
            parentCode: parentCode,
          }
        },
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.shareFileData.wardCodeInput.data.items = response.data.data;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      })
    },
    submitShareFile: function () {
      let that = this;
      let isValid = true;
      if (this.$hasAuthor(Roles.ADMIN) || this.$hasAuthor(Roles.PROVINCE)) {
        isValid &= this.shareFileData.districtCodeInput.data.validator.valid();
      } else if (this.$hasAuthor(Roles.DISTRICT)) {
        isValid &= this.shareFileData.wardCodeInput.data.validator.valid();
      }
      if (!isValid) {
        return;
      }
      let locations = []
      if (this.$hasAuthor(Roles.ADMIN) || this.$hasAuthor(Roles.PROVINCE)) {
        locations.push(this.shareFileData.districtCodeInput.data.model)
      }
      if (that.shareFileData.wardCodeInput.data.model) {
        for (let i = 0; i < that.shareFileData.wardCodeInput.data.model.length; i++) {
          if (that.shareFileData.wardCodeInput.data.model[i]) {
            locations.push(that.shareFileData.wardCodeInput.data.model[i].key)
          }
        }
      }
      this.loadingShareFile.value = true;
      this.$helper.loadDataSource({
        url: '/audio-file-location/add',
        dataSubmit() {
          return {
            fileId: that.shareFileData.fileId.model,
            locations: locations
          }
        },
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.showSuccessMsg({message: "Chia sẻ tệp tin thành công"})
            that.isShowPopupShareFile = false;
            that.loadingShareFile.value = false
            that.resetDataShareFile();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loadingShareFile.value = false
        }
      })
    },
    resetDataShareFile: function () {
      this.shareFileData.fileId.model = null;
      this.shareFileData.districtCodeInput.data.model = "";
      this.shareFileData.wardCodeInput.data.model = "";
    },
    loadDataDepartment: function () {
      let that = this;
      this.$helper.loadDataSource({
        url: "/common/listField",
        successCallback: function (response) {
          that.departmentsInput.data.items = response.data.data;
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    setupSelectOneAction: function (actionTypeKey, fileId, fileName) {
      let actionData = this.actionData.model;
      actionData.fileId = fileId || null;
      actionData.fileName = fileName || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
  },
  created: function () {
  },
  mounted() {
    this.loadDataDepartment();
  },
  watch: {
    'districtCodeInput.data.model': function (value) {
      if (value) {
        this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        this.wardCodeInput.options.disabled = false;
      } else {
        this.wardCodeInput.data.items = [];
        this.wardCodeInput.options.disabled = true;
      }
      this.wardCodeInput.data.model = null
    },
    'wardCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
    },
    'shareFileData.districtCodeInput.data.model': function (value) {
      if (value) {
        this.loadDataWard(value);
      } else {
        this.shareFileData.wardCodeInput.data.items = [];
      }
      this.shareFileData.wardCodeInput.data.model = null
    },
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: this.$helper.subtractNowDate(7).setHours(0, 0, 0, 0),
          end: new Date().setHours(23, 59, 59, 999)
        }
      }
    }
  },
  computed: {},
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect.input-error .multiselect__tags {
  border-color: #ff7070;
}
</style>
<style>
.row-2 .form-group {
  margin-top: 0 !important;
}
</style>
